
<div class="items-details-modal__header">
    <ci-icon-button 
    type="tonal" 
    name="close"
    class="items-details-modal__close-button"
    (click)="closeModal()"
    tabindex="0"
  ></ci-icon-button>
</div>